import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    url: "https://sermonsilsa.mecasite.com/",
    
    streamUrl: "", 
    streamStatus: 0,

    latestSermons: []
  },

  mutations: {
    
    setStream(state, data){      
      state.streamUrl = data.url
      state.status = data.status
    }

  },
  actions: {
    
  },
  modules: {
  }
})
